export interface MenuItemInterface {
  id: string;
  label: string;
  value: string;
  selectable?: boolean;
}

export function mapEnumDescriptorToMultiselectOptions(
  enumDescriptor: Record<string, string>,
  valuePrefix?: string,
): MenuItemInterface[] {
  return Object.entries(enumDescriptor).map(([key, value]) => ({
    id: key,
    label: value,
    value: `${valuePrefix || ''}${key}`,
    selectable: true,
  }));
}

const collator = new Intl.Collator('en', {
  sensitivity: 'base', // ignore case and diacritics for primary order
  caseFirst: 'lower', // when strings are equal ignoring case, lowercase comes first
});

export const sortAlphabetical = (data: MenuItemInterface[], dir: 'asc' | 'desc' = 'asc') => {
  if (!Array.isArray(data)) return data;
  const sign = dir === 'desc' ? -1 : 1;
  return [...data].sort((a, b) => sign * collator.compare(a.label, b.label));
};
